
import styled from "styled-components";
import theme from "~/styles/theme";
import { motion } from "framer-motion";

export const StyledMotionDiv = styled(motion.div)`
  background-color: ${theme.palette.neutral.primary.key};

  .div {
    background-color: ${theme.palette.brand.terciary.light};
  }
`;